<template>
  <section class="app-main" style="position:relative">
    <keep-alive >
      <iframe
        v-show="$route.meta.sysModel"
        id="mapFrame"
        name="mapFrame"
        :src="src+'?&project='+projectName+'&role='+role"
        width="100%"
        :height="height"
        style="position:absolute;top:3px;left:0;right:0;border: none;z-index:0"
      />
    </keep-alive>
    <transition name="fade" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
      <!-- <router-view :key="key"></router-view> -->
      <!--<router-view></router-view>-->
    </transition>
  </section>
</template>

<script>
import axios from 'axios'
import {getUserRole} from '@/api/calibrationInfo';
import { getToken } from '@/utils/auth'
export default {
  name: 'AppMain',
  data() {
    return {
      src: '',
      projectName: '',
      role: '',
      getToken: getToken().replace(/^Bearer /, ''),
      height: 0
    };
  },
  created() {
    const that = this
    this.height = (document.documentElement.clientHeight - 89) + 'px'
    axios.get('/static/commonConfig.json').then(({data}) => {
      that.projectName = data.projectName
      that.src = data.MAPURL
    })
    getUserRole().then(res => {
      var role = '';
      role = res.data.appraiser != undefined ? "appraiser" : role;
      role = res.data.appraisalAgency != undefined ? "appraisalAgency" : role;
      role = res.data.technicalOorganizer != undefined ? "technicalOorganizer" : role;
      this.role = res.data.sysadmin != undefined ? "sysadmin" : role;
    })
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue